import autobind from 'core-decorators/lib/autobind';
import React from 'react';
import { StyleSheet, css } from 'aphrodite';



@autobind
class HowItWorks extends React.Component {
  state = {
    onLocalHost: false,
  };

  componentDidMount(){
   
  }
  render() {
    return (
      <React.Fragment>
        <div className={css(styles.wrapper)}>
          <div className={css(styles.step1Wrapper)}>
            <div className={css(styles.step1First)}>
              <h5>
                HOW TO START
              </h5>
              <h4 className={css(styles.title)}>
                Sign up with your Instagram account
              </h4>
              <div className={css(styles.counterWrapper)}>
                <div className={css(styles.count)}>
                  <div className={css(styles.blue)}>1.</div>
                  <div className={css(styles.countText)}>Authorize Instagram access.</div>
                </div>
                <div className={css(styles.count)}>
                  <div className={css(styles.blue)}>2.</div>
                  <div className={css(styles.countText)}>Enter basic details.</div>
                </div>
                <div className={css(styles.count)}>
                  <div className={css(styles.blue)}>3.</div>
                  <div className={css(styles.countText)}>Choose your website title and URL (e.g. https://<span className={css(styles.blue)}>username</span>.miminaa.co)</div>
                </div>
              </div>
            </div>
            <img alt="how it works minimaa" className={css(styles.img1)} src="../../assets/howItWorks1.png"/>
          </div>
        </div>
        <div className={css(styles.wrapper2)}>
          <div className={css(styles.step2Wrapper)}>
            <h5>
              HOW TO UPLOAD
            </h5>
            <h4 className={css(styles.title)}>
              Post to instagram and organise with hashtags
            </h4>
            <p className={css(styles.counterWrapper)}>
              Use <span className={css(styles.blue)}>#hashtags</span> on Instagram to categorise content on your Minimaa website.
            </p>
            <img alt="how it works minimaa" className={css(styles.img2)} src="../../assets/howItWorks2.png"/>
          </div>
          <div className={css(styles.step3Wrapper)}>
            <h5>
              HOW TO CUSTOMISE
            </h5>
            <h4 className={css(styles.title)}>
              Customise your website in your dashboard
            </h4>
            <p className={css(styles.counterWrapper)}>
              Match <span className={css(styles.blue)}>#hashtags</span> to portfolio categories inside the dashboard and Minimaa will do the rest. 
            </p>
            <img alt="how it works minimaa" className={css(styles.img2)} src="../../assets/howItWorks3.png"/>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
const styles = StyleSheet.create({
  wrapper: {
    position:"relative",
    height:295,
    width:560,
    '@media (max-width: 1020px)': {
      marginTop:60,
    },
    '@media (max-width: 600px)': {
      height:"auto",
      maxWidth:330,
      width:"100%",
    },
  },
  wrapper2:{
    position:"relative",
    
    width:560,
    display:"flex",
    justifyContent:"space-between",
    alignItems:"flex-end",
    marginTop:24,
    '@media (max-width: 600px)': {
      flexDirection:"column",
      maxWidth:330,
      width:"100%",
      marginTop:64,
    },
  },
  step1Wrapper:{
    boxShadow: "0px 2px 12px rgba(21, 23, 54, 0.15)",
    display:"flex",
    justifyContent:"space-between",
    alignItems:"center",
    '@media (max-width: 600px)': {
      flexDirection:"column",
    },
  },
  step2Wrapper:{
    boxShadow: "0px 2px 12px rgba(21, 23, 54, 0.15)",
    padding:"36px 24px 24px 24px",
    width:220,
    '@media (max-width: 600px)': {
      width:"auto",
      
    },
  },
  step3Wrapper:{
    boxShadow: "0px 2px 12px rgba(21, 23, 54, 0.15)",
    padding:"36px 24px 24px 24px",
    width:220,
    '@media (max-width: 600px)': {
      width:"auto",
      marginTop:64,
    },
  },

  step1First:{
    padding:"36px 24px",
    width:240,
    fontSize:12,
    '@media (max-width: 600px)': {
      width:"calc(100% - 48px)",
    },
  },
  step1Second:{

  },
  img1:{
    width:230,
    marginTop:36,
    marginRight:24,
    '@media (max-width: 600px)': {
      width:"calc(100% - 48px)",
      padding:"0px 24px 24px 24px",
      marginTop:0,
      marginRight:0,
    },
  },
  img2:{
    width:"calc(100%)",
    marginTop:35,
  },
  title:{
    width:200,
    '@media (max-width: 600px)': {
      width:"calc(100%)",
    },
  },
  counterWrapper:{
    marginTop:15,
  },
  count:{
    display:"flex",
    marginBottom:8,
  },
  blue:{
    color:"#3A80E4",

  },
  countText:{
    marginLeft:5,
  },

  
  

});

export default HowItWorks;